import { connect } from 'react-redux'
import {GlassWallComponent} from '../lib/glassWallComponent.esm'
import { changeLeftSideGlassHeight, changeLeftSideGlassWidth, doorFromLeftUpdated, toggleLeftSideGlass, changeRightSideGlassHeight, 
    changeRightSideGlassWidth, toggleRightSideGlass, changeDoorHeight, toggleUpGlass, changeUpGlassHeight, changeSpaceUnderDoor, totalWidthChanged,
    markGlassWallEdited
} from '../actions/door';
import {  getGlassMeasurementLimits } from '../helpers/glassWallBuilder';
import { getGlasslMaterial, getGlassListlMaterial } from '../reducers/materialStore';
import { contentRoot } from '../config.js';




const mapStateToProps = (state, ownProps) => {
    let glassMaterial = getGlasslMaterial(state, state.measurements.glassMaterial);
    let color = glassMaterial ? glassMaterial.color : "white";
    color = color != "#000000" ? color : "white";
    let listMaterial = getGlassListlMaterial(state, state.measurements.glassListMaterial);
    let listColor = listMaterial ? listMaterial.color : "grey"; 
    
    return {
        measurements: state.measurements,        
        glassSizeLimits: state.measurements.doorSizeConstraints,
        glassColor: color,
        background: contentRoot +"img/saunatausta.jpg",
        slateImage:  contentRoot + "img/laatta.jpg",
        addGlass:  contentRoot + "img/Add.svg",
        removeGlass:  contentRoot + "img/Remove.svg",
        verticalArrows: contentRoot +"img/twoWayVerticalArrow.png",
        horizontalArrows: contentRoot + "img/twoWayHorizontalArrow.png",
        penIcon: contentRoot + "img/pen.png",
        listColor: listColor,
        hideDoorFromLeftMeasurement: state.plan.hasBench
    }
}
const mapDispatchToProps = (dispatch, ownProps) => ({
    leftSideGlassHeightChanged: (h) => {
        dispatch(markGlassWallEdited());
        dispatch(changeLeftSideGlassHeight(h));
    },  
    leftSideGlassWidthChanged: (w) => {
        dispatch(markGlassWallEdited());
        dispatch(changeLeftSideGlassWidth(w));
    },
    leftSideGlassToggled: () => {
        dispatch(markGlassWallEdited());
        dispatch(toggleLeftSideGlass());
    },
    rightSideGlassHeightChanged: (h) => {
        dispatch(markGlassWallEdited());
        dispatch(changeRightSideGlassHeight(h));
    },
    rightSideGlassWidthChanged: (w) => {
        dispatch(markGlassWallEdited());
        dispatch(changeRightSideGlassWidth(w));
    },
    rightSideGlassToggled: () => {
        dispatch(markGlassWallEdited());
        dispatch(toggleRightSideGlass());
    },
    doorHeightChanged: (h) => {
        dispatch(markGlassWallEdited());
        dispatch(changeDoorHeight(h));
    },
   doorFromLeftChanged:(d)=>{
        dispatch(markGlassWallEdited());
        dispatch(doorFromLeftUpdated(d));
   },
   totalWidthChanged:(d)=>{   
       dispatch(markGlassWallEdited());
       dispatch(totalWidthChanged(d));

    },
    spaceUnderDoorChanged:(s)=>{
        dispatch(markGlassWallEdited());
        dispatch(changeSpaceUnderDoor(s));
    },   
    upGlassToggled: () => {
        dispatch(markGlassWallEdited());
        dispatch(toggleUpGlass());
    },
    upGlassHeightChanged:(h)=>
    {
        dispatch(markGlassWallEdited());
        dispatch(changeUpGlassHeight(h));  
    }    
});


const GlassWallContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(GlassWallComponent)

export default GlassWallContainer

